module.exports = __webpack_public_path__ + "img/icon-tree-big.ce843ecf.png";